import * as actionTypes from './actionTypes';
import merge from 'deepmerge';
import initialState from 'store/initialState';
const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;
export default function(state = initialState.optimizelyABTest, action) {
  switch (action.type) {
    case actionTypes.SET_OPTIMIZELY_AB_TEST: {
      return merge(state, action.payload, {
        arrayMerge: overwriteMerge
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/optimizelyABTest/reducer.js